/**
 * 生词本工具栏业务逻辑钩子
 * 提供搜索和排序功能的逻辑处理
 */
import { useState } from 'react';
/**
 * 生词本工具栏业务逻辑钩子
 * 提供搜索和排序功能的业务逻辑
 */
export function useVocabularyToolbar({ initialSearchText = '', initialSortBy = 'time-desc', onSearch, onSortChange, } = {}) {
    // 状态
    const [searchText, setSearchText] = useState(initialSearchText);
    const [sortBy, setSortBy] = useState(initialSortBy);
    // 处理搜索
    const handleSearch = (text) => {
        if (onSearch) {
            onSearch(text);
        }
    };
    // 处理排序变更，确保类型兼容性
    const handleSortChange = (sortOption) => {
        const typedSortOption = sortOption;
        setSortBy(typedSortOption);
        if (onSortChange) {
            onSortChange(typedSortOption);
        }
    };
    return {
        searchText,
        sortBy,
        setSearchText,
        setSortBy,
        handleSearch,
        handleSortChange,
    };
}
//# sourceMappingURL=useVocabularyToolbar.js.map